import { CircularProgress } from '@material-ui/core'
import React from 'react'

interface Props {
  isLoading: boolean
  size?: string
}

const Loader: React.FC<Props> = ({ isLoading, size = '50px' }: Props) =>
  isLoading ? <CircularProgress size={size} /> : null

export default Loader
